module.exports = __webpack_public_path__ + "img/phone.f4afc9b.svg";